import {
  HeroCarousel,
  HeroCarouselProps,
} from "@/components/Content/HeroCarousel.tsx";
import { useFullItemsMainTab } from "../hooks/useFullItemsMainTab.tsx";

type MainTabHeroCarouselProps = Omit<HeroCarouselProps, "fullItems">;

export const MainTabHeroCarousel = ({
  collection,
  ...props
}: MainTabHeroCarouselProps) => {
  const { fullItems } = useFullItemsMainTab(collection.Items);

  return (
    <HeroCarousel {...props} fullItems={fullItems} collection={collection} />
  );
};
